<template>
	<modal-box @close="$emit('close')" :header="$t('labels.general.add_subscription')">
		<div slot="buttons">
			<button @click="selectTab('service')" :class="cssClass('service')">{{ $t('labels.general.service') }}</button>
			<button @click="selectTab('options')" :class="cssClass('options')">{{ $t('labels.general.options') }}</button>
		</div>
		<subscription-form-service v-show="isSelectedTab('service')" :user_uid="user_uid" :services="services" @selected="onSelected"/>
		<subscription-form-options v-show="isSelectedTab('options')" :user_uid="user_uid" :service="selectedService" :subscription_options="subscriptionOptions" :form="form" @success="addSubscription"/>
	</modal-box>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
import SubscriptionFormService from './SubscriptionFormService'
import SubscriptionFormOptions from './SubscriptionFormOptions'
export default {
	components: {
		SubscriptionFormService,
		SubscriptionFormOptions
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			name: 'subscription form',
			services: new ApiCollection(),
			form: new FormObject(),
			subscriptionOptions: {
				frequency_payment: -1,
				days: '',
				units: 1,
				auto_renew: true
			},
			subscriptionOptionsExtra: {
				discount_unit: 0,
				discount_subscription: 0
			},
			selectedTab: 'service',
			selectedService: null
		}
	},
	computed: {
		subscriptionModel () {
			let price_base_unity = this.selectedService.monthly_price_base_unity
			let price_unity = this.selectedService.monthly_price_unity
			let tax_unity = this.selectedService.monthly_tax_unity

			if (this.subscriptionOptions.frequency_payment == '-2') {
				price_base_unity = this.selectedService.yearly_price_base_unity
				price_unity = this.selectedService.yearly_price_unity
				tax_unity = this.selectedService.yearly_tax_unity
			}

			const tax_percent = this.selectedService.tax_percent
			const tax_percent_label = this.selectedService.tax_percent_label

			const serviceId = this.selectedService ? this.selectedService.id : null
			const serviceOptions = {
				price_base_unity: this.price_base_unity,
				price_unity: this.price_unity,
				tax_unity: this.tax_unity,
				tax_percent: this.tax_percent,
				tax_percent_label: this.tax_percent_label
			}
			return {
				service_id: serviceId,
				...serviceOptions,
				...this.subscriptionOptions,
				...this.subscriptionOptionsExtra
			}
		}
	},
	methods: {
		selectTab (tabName) {
			if (tabName === 'options' && !this.selectedService) return
			this.selectedTab = tabName
		},
		isSelectedTab (tabName) {
			return this.selectedTab === tabName
		},
		cssClass (tabName) {
			return this.isSelectedTab(tabName) ? 'active' : ''
		},
		onSelected (value) {
			const oldVal = this.selectedService
			this.selectedService = value

			this.subscriptionOptions = {
				frequency_payment: -1,
				days: '',
				units: 1,
				auto_renew: true
			}

			this.selectTab('options')
		},
		getServices () {
			this.services.loading = true
			this.$api.subscriptions.services.getAll(this)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.services.getAll OK', response)()
					this.services.data = response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.services.getAll ERROR', error)()
					this.services.error = error
				}).finally(() => {
					this.services.loading = false
				})
		},
		addSubscription () {
			this.form.loading = true
			this.$api.subscriptions.add(this, this.user_uid, this.subscriptionModel)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.add OK', response)()
					this.$root.$emit('add-floating-box', { title: 'Success', text: 'Subscription created.' })
					this.$emit('close', { reload: true })
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	mounted () {
		this.getServices()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/SubscriptionForm.vue